<template>
    <ProSpaceHLayout :gap="5" class="home-dashboard-kpi address-program__kpi-block">
        <div class="home-dashboard-kpi__title text-color-gray text-size-12">
            {{ title }}
        </div>
        <AddressProgramKpiStats class="home-dashboard-kpi__stats"
            :plan-prop="plan"
            :fact-prop="fact"
            :percent="percent"
            :formatNumber="formatNumber"
            :minFractionDigits="minFractionDigits"
            :separatorType="separatorType"
            :use-raw-values="useRawValues"
            :revertKPI="revertKPI"
        />
    </ProSpaceHLayout>
</template>

<script>
import {
  ProSpaceHLayout,
  ProSpaceVLayout,
} from "@prospace/prospace-components-library";
import AddressProgramKpiStats from "../../AddressProgramOrders/components/AddressProgramKpiStats.vue";
export default {
    name: "HomeDashboardKpi",
    components: {
        ProSpaceHLayout,
        ProSpaceVLayout,
        AddressProgramKpiStats
    },
    props: {
        title: {
            type: String,
            required: true
        },
        plan: {
            type: Number,
            required: true
        },
        fact: {
            type: Number,
            required: true
        },
        percent: {
            type: Boolean,
            default: false
        },
        formatNumber: {
            type: Boolean,
            default: false
        },
        minFractionDigits: {
            type: Number,
            default: 2
        },
        separatorType: {
            type: String,
            default: ''
        },
      useRawValues: {
        type: Boolean,
        default: false
      },
      revertKPI: {
        type: Boolean,
        default: false
      }
    }
}
</script>

<style lang="scss">
.home-dashboard-kpi {
    padding: 10px;
    background: var(--prospace-ui-bg);
    border-radius: 5px;
    &__title {
        width: 30%;
        overflow: hidden;
        white-space: break-spaces;
        text-overflow: ellipsis;
        @container (max-width: 1130px) {
          width: 100%;
        }
    }
    &__stats {
        width: 70%;
        @container (max-width: 1130px) {
          width: 100%;
        }
      .kpi-stats__result-value {
        font-size: 18px;
      }
      @container (max-width: 1130px) {
        height: auto;
        flex-direction: column;
      }
    }
    @container (max-width: 1130px) {
      flex-direction: column !important;
      align-items: flex-start !important;
    }
}
</style>
